import React, { useState, useEffect } from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';
import { CloseButton } from '../Buttons';
import media from '../../utils/media';
import { getFadeTransition } from '../../utils/transitions';
/* Prevents body from scrolling when modal is open */
const BodyScrollPreventer = createGlobalStyle `
  body {
    overflow: ${({ isContained }) => (!isContained ? 'hidden !important' : 'normal')};

    ${media.tablet} {
      overflow: hidden !important;
    }
  }
`;
const Container = styled.dialog `
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0px;
  z-index: 99999;
  background-color: ${({ theme, asLightbox }) => (asLightbox ? 'rgba(0, 0, 0, 0.8)' : theme.primaryWhite)};
  display: flex;
  justify-content: center;
  border: none;
  animation: 0.5s ease-out 0s 1
    ${({ shouldRender }) => (shouldRender && getFadeTransition(0, 1)) || getFadeTransition(1, 0)};

  ${({ isContained }) => isContained &&
    css `
      position: absolute;
      z-index: 10;
    `}

  ${media.tablet} {
    position: fixed;
    z-index: 99999;
  }

  /* show close button perm on tablet/mobile */
  ${media.tablet} {
    #button-container {
      opacity: 1 !important;
    }
  }
`;
const ButtonPosition = styled.div `
  position: absolute;
  z-index: 99;
  top: 20px;
  right: 20px;
  opacity: ${({ shouldRender }) => (shouldRender ? '1' : '0')};
  transition: 0.3s;
`;
export const Modal = ({ children, onModalClose, isContained, isOpen, closeIconLabel, asLightbox, shouldModalClose, }) => {
    if (!isOpen) {
        return null;
    }
    const [shouldRender, setShouldRender] = useState(isOpen);
    const [onHover, setOnHover] = useState(false);
    // handles fade out
    useEffect(() => {
        if (shouldModalClose) {
            setShouldRender(false);
        }
    }, [shouldModalClose]);
    const animationEnds = () => {
        if (!shouldRender) {
            onModalClose();
        }
    };
    return (React.createElement(Container, { isContained: isContained, open: isOpen, shouldRender: shouldRender, onAnimationEnd: animationEnds, asLightbox: asLightbox, onMouseEnter: () => setOnHover(true), onMouseLeave: () => setOnHover(false) },
        React.createElement(BodyScrollPreventer, { isContained: isContained }),
        React.createElement(ButtonPosition, { id: "button-container", shouldRender: onHover },
            React.createElement(CloseButton, { "aria-label": closeIconLabel, isCircular: true, iconSize: 30, onClick: () => {
                    setShouldRender(false);
                } })),
        children));
};
